import '@data/Simulations/pipeline/blocks/ShadowBlock';
import { ShadowBlockParameters } from '@data/Simulations/pipeline/blocks/ShadowBlock';
import { ControllerManager } from '@gui/controller/ControllerManager';
import { Box, Checkbox, FormControl, FormControlLabel, FormLabel } from '@mui/material';
import React, { useEffect, useMemo } from 'react';
import { usePipelineBlockParams } from './usePipelineBlockParams';

type ShadowFilterParametersProps = {
    blockId: string;
};

/** Default values */
export const getShadowFilterDefaultParams = (): Pick<ShadowBlockParameters, 'isInverted'> => ({
    isInverted: false,
});

const ShadowParameters: React.FC<ShadowFilterParametersProps> = ({ blockId }) => {
    const params = usePipelineBlockParams<ShadowBlockParameters>(blockId);

    const pipelineController = useMemo(() => ControllerManager.getInstance().getPipelineController(), []);

    const updateParams = (partial: Partial<ShadowBlockParameters>) => {
        pipelineController.updateBlockParams(blockId, partial);
    };

    /** Ensure defaults and compute meshes when first mounted */
    useEffect(() => {
        if (!params) {
            updateParams(getShadowFilterDefaultParams());
            return;
        }

        if (params.isInverted == null) {
            updateParams({ isInverted: false });
        }
    }, [params]);

    const isInverted = params?.isInverted ?? false;

    const handleInvertChange = (checked: boolean) => {
        updateParams({ isInverted: checked });
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <FormControl className="panel-compact-control-stack">
                <FormLabel component="legend">Shadow Filter</FormLabel>

                <FormControlLabel
                    control={<Checkbox checked={isInverted} onChange={(e) => handleInvertChange(e.target.checked)} />}
                    label="Invert direction"
                />
            </FormControl>
        </Box>
    );
};

export default ShadowParameters;
